export const getAnnotations = (state) => {
  return state.annotations.data;
};

export const getAreAnnotationsLoading = (state) => {
  return !!state.annotations.loading;
};
